import React, {useState, useEffect} from "react";
import "./TypeWriter.scss";
import content from "../../content.generated";

// Credential rows revealed one at a time inside a terminal-style window.
// Each row's label appears immediately; its value types out once, then
// the whole thing sits still — no looping, no fake commands.
// Content is defined in content.yaml under `typewriter:`.
const ROWS = content.typewriter.rows;
const STATS = content.typewriter.stats;

const TYPE_SPEED = 32; // ms per character
const ROW_GAP = 260; // ms pause before the next row starts

export default function TypeWriter() {
  const [rowIdx, setRowIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);

  const active = rowIdx < ROWS.length ? ROWS[rowIdx] : null;
  const typingActive = !!active && charIdx < active.value.length;

  useEffect(() => {
    if (!active) return; // all rows revealed — nothing left to animate

    if (typingActive) {
      const t = setTimeout(() => setCharIdx(c => c + 1), TYPE_SPEED);
      return () => clearTimeout(t);
    }

    const t = setTimeout(() => {
      setRowIdx(i => i + 1);
      setCharIdx(0);
    }, ROW_GAP);
    return () => clearTimeout(t);
  }, [active, typingActive, charIdx]);

  return (
    <div className="typewriter-wrap">
      <div className="typewriter-window">
        <div className="typewriter-bar">
          <span className="tw-dot tw-red"></span>
          <span className="tw-dot tw-yellow"></span>
          <span className="tw-dot tw-green"></span>
          <span className="tw-bar-title">rakesh@portfolio: ~/whoami</span>
        </div>

        <div className="typewriter-body">
          {ROWS.map((row, i) => {
            const revealed = i < rowIdx;
            const isActive = i === rowIdx;
            if (!revealed && !isActive) return null;

            const shownValue = revealed
              ? row.value
              : row.value.substring(0, charIdx);

            return (
              <div className="tw-row" key={row.label}>
                <span className="tw-label">{row.label}</span>
                <span className={`tw-value ${row.gold ? "tw-gold" : ""}`}>
                  {shownValue}
                  {isActive && typingActive && (
                    <span className="tw-cursor">▌</span>
                  )}
                </span>
              </div>
            );
          })}

          {rowIdx >= ROWS.length && (
            <div className="tw-row tw-row-final">
              <span className="tw-label">$</span>
              <span className="tw-cursor tw-cursor-idle">▌</span>
            </div>
          )}
        </div>
      </div>

      <div className="tw-stats">
        {STATS.map((s, i) => (
          <a key={i} className="tw-stat" href={s.href}>
            <span className="tw-stat-num">{s.num}</span>
            <span className="tw-stat-label">{s.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
